import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { aboutSection } from '../mock/data';

const About = () => {
  return (
    <section id="about" className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left - Image */}
          <div className="relative animate-in fade-in slide-in-from-left duration-700">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="/generated/atelier-premium.jpg"
                alt="Atelier mécanique moderne et lumineux CarMaintenance"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#52a675]/20 to-transparent" />
            </div>
          </div>

          {/* Right - Content */}
          <div className="space-y-6 animate-in fade-in slide-in-from-right duration-700 delay-150">
            <div className="inline-block">
              <span className="bg-[#52a675]/10 text-[#52a675] px-4 py-2 rounded-full text-sm font-semibold">
                Notre Vision
              </span>
            </div>
            
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
              {aboutSection.title}
            </h2>
            
            <p className="text-lg text-gray-600 leading-relaxed">
              {aboutSection.description}
            </p>

            <div className="pt-4">
              <Link to="/a-propos-de-nous">
                <Button
                  size="lg"
                  className="bg-[#52a675] hover:bg-[#3d8a5c] text-white px-8 py-6 text-lg shadow-lg hover:shadow-xl transition-all duration-300 group"
                >
                  {aboutSection.ctaText}
                  <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </Button>
              </Link>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-gray-200">
              <div>
                <div className="text-3xl font-bold text-[#52a675]">1500+</div>
                <div className="text-sm text-gray-600 mt-1">Clients actifs</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-[#52a675]">98%</div>
                <div className="text-sm text-gray-600 mt-1">Satisfaction</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-[#52a675]">24/7</div>
                <div className="text-sm text-gray-600 mt-1">Support</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
